import React from 'react';
import { connect } from 'react-redux';
import { keyBy } from 'lodash';
import { compose } from 'redux';
import Table from '../../../../common/table/Table';
import { getThTooltip } from '../common/helpers';
import RowClick from '../../../../common/RowClick';
import Const from './Const';
import { REDUCER_NAME as CURRENT_REDUCER } from './reducer';
import { formatPercent } from '../../../../helpers/Text';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import { I18n } from 'react-redux-i18n';

class ValueTable extends React.Component {
  getSchema = () => {
    return Object.keys(Const.value).map(item => {
      const key = Const.value[item];
      const title = `strategy.listValue.${item}`;
      const result = {
        key,
        title,
        thTooltip: getThTooltip(item, 'value'),
      };

      if (key === Const.value.timeRange) {
        return {
          ...result,
          render: (text, item) => {
            const year =
              item.timeRange === 1
                ? I18n.t('strategy.year')
                : I18n.t('strategy.years');
            return (
              <div className="text-left">{`${item.timeRange} ${year}`}</div>
            );
          },
        };
      }
      if (key === Const.value.stockePicks) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          render: (text, item) => {
            return <div>{formatPercent(item.averageStock) + ' % '}</div>;
          },
        };
      }
      if (key === Const.value.vnIndex) {
        return {
          ...result,
          valueFromItem: item => item.averageIndex,
          thStyle: { textAlign: 'right' },
          render: (text, item) => {
            return <div>{formatPercent(item.averageIndex) + ' % '}</div>;
          },
        };
      }

      return result;
    });
  };

  render() {
    const { investData } = this.props;
    const { valueInvestTable, isFetching } = investData;

    const listIds = valueInvestTable.map(item =>
      getDataFollowKeyByDot(item, 'timeRange'),
    );

    const listFullData = keyBy(valueInvestTable, 'timeRange');
    return (
      <Table
        resizable={true}
        columnDraggable={true}
        rowDraggable={false}
        getDataFromRedux={() => listFullData}
        isLoading={isFetching}
        ids={listIds}
        schema={this.getSchema()}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    investData: state[CURRENT_REDUCER].investData,
  };
};

const enhance = compose(connect(mapStateToProps));
export default enhance(ValueTable);
